import React, { useContext } from 'react';
import { Grid, Typography, Button } from '@mui/material';
import DataTable from '../../../sharedModules/dataTable';
import { ChillerLogsContext } from '../contexts/ChillerLogsContext';

const PreviousLogsListTable: React.FC = () => {
  let { setPreviousLogDialogOpen, setLogForPreviousLogModal, historicalLogs, historicalTableIsPartial } =
    useContext(ChillerLogsContext);

  const handleRowClick = (row: any) => {
    setPreviousLogDialogOpen(true);
    setLogForPreviousLogModal(row);
  };

  const historicalJobColumns = [
    {
      name: 'Order No.',
      selector: 'order_no',
      sortable: true,
      grow: 0.5,
    },
    {
      name: 'Submitted Date',
      selector: 'submitted_date',
      sortable: true,
    },
    {
      name: 'Logging Tech',
      selector: 'tech',
      sortable: true,
    },
    {
      name: 'Status',
      selector: 'status',
      sortable: true,
      cell: (row: Record<string, string>) => (
        <div
          style={{
            fontWeight: 700,
            textTransform: 'uppercase',
            color: 'green',
          }}
        >
          {row.status}
        </div>
      ),
    },
    {
      name: 'Actions',
      selector: 'actions',
      sortable: true,
      cell: (row: Record<string, string>) => (
        <div>
          <Button variant="contained" color="primary" onClick={() => handleRowClick(row)}>
            View
          </Button>
        </div>
      ),
    },
  ];

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant="h6" style={{ marginBottom: 10 }}>
          Previous Logs
        </Typography>
      </Grid>
      {historicalTableIsPartial && (
        <Grid item xs={12}>
          {/* Make this typography Italic */}
          <Typography variant="body1" style={{ fontSize: 12, fontStyle: 'italic' }}>
            Note: Your current data came from a device load, which only stores two previous logs.
          </Typography>
          <Typography variant="body1" style={{ marginBottom: 10, fontSize: 12, fontStyle: 'italic' }}>
            If this asset has more than two logs, they can be obtained by loading from the server.
          </Typography>
        </Grid>
      )}
      <Grid item xs={12}>
        <DataTable
          title=""
          columns={historicalJobColumns}
          data={historicalLogs}
          onRowClicked={(row: any) => handleRowClick(row)}
          striped
          dense
          highlightOnHover
          pointerOnHover
          pagination={false}
          noHeader
        />
      </Grid>
    </Grid>
  );
};
export default PreviousLogsListTable;
